<section class="container">
  <section class="row">
    <section class="col-12 p-0"
      [ngClass]="{'col-lg-4 col-xl-4':urlPath==='dashboard', 'col-xl-5':urlPath==='reservation-overview'}">
      <section class="container">
        <div *ngIf="showPieChart" class="position-relative centerChartDiv">
          <div id="popup" class="piechart-hover pie-chart-shipped-hover height-60" (mouseenter)="showHidePopup(true)"
            (mouseleave)="showHidePopup(false)">
            <span class="pie-hover-static-txt">Shipment status</span>
            <div class="Scheduled commonSeries commonSeriesHead d-flex mt-2 mb-3 font-weight-bold">
              <span class="colorCode" [ngStyle]="{ 'background': statusColorCode }"></span>
              <span>{{hoveredStatus}}</span>
            </div>
            <div class="w-100 pieChart-child mCustomScrollbar _mCS_7 mCS_no_scrollbar height-30">
              <div id="mCSB_7" class="mCustomScrollBox mCS-dark mCSB_vertical mCSB_inside" tabindex="0"
                style="max-height: none;">
                <div id="mCSB_7_container" class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
                  style="position:relative; top:0; left:0;" dir="ltr">
                  <div class="d-flex common-pie-header">
                    <div class="col-2 p-0">#</div>
                    <div class="col-8 pr-0">Presentations</div>
                    <div class="col-2 d-flex justify-content-end p-0">Units/Doses</div>
                  </div>

                  <div class="d-flex Rejected commonSeries popoverProduct p-2"
                    *ngFor="let product of chartStatusPopoverData">
                    <div class="col-2 p-0">{{product?.productCode}}</div>
                    <div class="col-7 pr-0 pl-3">
                      <!-- <p>{{product.productName}}</p> -->
                      <p [innerHTML]="product?.productName"></p>
                    </div>
                    <div class="col-2 p-0 text-end">{{product?.productUnit}}/{{product?.productDose}}</div>
                  </div>
                </div>
                <div id="mCSB_7_scrollbar_vertical"
                  class="mCSB_scrollTools mCSB_7_scrollbar mCS-dark mCSB_scrollTools_vertical" style="display: none;">
                  <div class="mCSB_draggerContainer">
                    <div id="mCSB_7_dragger_vertical" class="mCSB_dragger"
                      style="position: absolute; min-height: 30px; display: block; height: 159px; max-height: 148.667px; top: 0px;">
                      <div class="mCSB_dragger_bar" style="line-height: 30px;"></div>
                    </div>
                    <div class="mCSB_draggerRail"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <canvas #chartCanvas baseChart width="235" height="235" [datasets]="doughnutChartData" id="canvas"
           [labels]="doughnutChartLabels" 
           [chartType]="doughnutChartType" 
           [type]="doughnutChartType"
           [legend]="false" 
           [tooltip]="false"
            [options]="doughnutChartOptions">
          </canvas>
          <section *ngIf="doughnutChartData.length!==0"
            class="position-absolute dose-total-Section-reservation-details">
            <section class="col-xl-12 d-flex justify-content-center p-0"
              [ngClass]="{'padding-left':urlPath==='dashboard', 'padding-left':urlPath==='reservation-overview'}">
              <img src="/assets/icons/chartImage.png" alt="chart-image">
            </section>

            <section class="col-xl-12 d-flex justify-content-center p-0">
              <span class="mt-1 doseNum text-center">{{chartCenterUnits}} of {{chartCenterDoses}}</span>
            </section>
            <section class="col-xl-12 text-center d-flex justify-content-center p-0">
              <span class="text-center chartCenterStatus"> Doses {{chartCenterStatus | lowercase}}</span>
            </section>
          </section>
        </div>
        <div class="col text-center mt-2">
          <div>Download Shipping Info:</div>
          <div class="cursor-pointer mt-2" (click)="downloadXLS()">
            <a class="xls">
              <img class="xlsIcon mb-1 mr-1" src="../../../assets/icons/{{baseSiteId}}/excel_new.png">
              XLS
            </a>
          </div>
        </div>
      </section>
    </section>

    <!--Section added for STS case -STARTS-->
    <section *ngIf="orderStatusDisplay=='Shipped' && stsFlag; else normalTableFlow" class="col-12 col-lg-8 p-0 tableDiv"
      [ngClass]="{'col-xl-8':urlPath==='dashboard', 'col-xl-7':urlPath==='reservation-overview'}">
      <div [innerHTML]="flupara"></div>
      <div class="pl-2">
        <button class="btn-secondary" (click)="redirectToShippingSchedule()">Manage shipping schedule</button>
      </div>
    </section>
    <!--Section added for STS case -ENDS-->

    <!--Normal table logic as is in case above condition of sts and shipped not met-->
    <ng-template #normalTableFlow>
      <section class="col-12 p-0 tableDiv"
        [ngClass]="{'col-lg-8 col-xl-8':urlPath==='dashboard', 'col-xl-7':urlPath==='reservation-overview'}">
        <table aria-describedby="cardDetailsTable" id="reservationTable" class="table tableDisplay w-100"
          [ngClass]="{'reservationDashboardTableWidth': urlPath==='dashboard'}">
          <thead>
            <tr class="header-row">
              <th scope="col" class="header" (click)="sortColumn($event, 'shipmentStatus', reservationData, 'normal')">
                {{'orderConfirmation.shipmentStaus'|cxTranslate}}
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th scope="col" class="header">{{'orderConfirmation.shipDate'|cxTranslate}}</th>
              <th scope="col" class="header">{{'orderConfirmation.unitsDoses'|cxTranslate}}</th>
              <th scope="col" class="header">Tracking number</th>
            </tr>
          </thead>

          <tbody>
            <tr class="content-row" *ngFor="let data of reservationData;let j=index"
              [ngClass]="{'alternate-Row':j%2===0}">
              <td class="statusTd font-weight-bold cursor-pointer" title="{{data.shipmentStatus}}"
                (click)="openShippingPopup(content,data?.shipmentStatus); setStatusColorCode(data.shipmentStatus)"
                [ngStyle]="(data?.shipmentStatus != 'Shipped' && data?.shipmentStatus != 'Completed') ? {'cursor': 'text'} : {}">
                <span class="colorCode d-inline-flex mt-0" [ngStyle]="{ 'background': data.statusColor }"></span>
                {{data?.shipmentStatus}}
                <ng-template #content let-modal>
                  <div class="closeBtnContainer">
                    <img class="closeBtn float-right" src="../../../assets/icons/close.svg" (click)="dismissModal()">
                  </div>
                  <div class="modal-body detailsModal">
                    <div class="col p-0 mt-21">
                      <h6 class="title">Shipment Status</h6>
                      <div class="mb-2 shippedHeader pl3 shipmentStatus">
                        <span class="colorCode d-inline-flex mt-0"
                          [ngStyle]="{ 'background': data.statusColor }"></span>
                        {{data?.shipmentStatus}}
                      </div>
                      <div class="col bg-grey shipmentDetailsContainer">
                        <div class="col d-flex shippingPadding">
                          <div class="col">
                            <div class="shippingHeader">
                              <p class="mb-2">Ship date</p>
                            </div>
                            <div><span *ngIf="data.shipDate">{{data?.shipDate == 'TBD' ? data?.shipDate :data?.shipDate | date: "MM/dd/yyyy"}}</span>
                              <span class="text-center" *ngIf="!data.shipDate">-</span>
                            </div>
                          </div>
                          <div class="col">
                            <div class="shippingHeader">
                              <p class="mb-2">Invoice</p>
                            </div>
                            <div><a class="pdfLink" *ngIf="data.invoice"
                                (click)="downloadInvoice(data?.invoice)">{{data?.invoice}}</a>
                              <span class="text-center" *ngIf="!data.invoice">-</span>
                            </div>
                          </div>
                          <div class="col">
                            <div class="shippingHeader">
                              <p class="mb-2">Tracking #</p>
                            </div>
                            <div><a class="pdfLink" *ngIf="data.trackingId"
                                (click)="openTrackingURL(data?.trackingId, data?.trackingURL)">{{data?.trackingId}}</a>
                              <span class="text-center" *ngIf="!data.trackingId">-</span>
                            </div>
                          </div>
                          <div class="col">
                            <div class="shippingHeader">
                              <p class="mb-2">Carrier</p>
                            </div>
                            <div><span *ngIf="data.carrier.name">{{data?.carrier?.name}}</span>
                              <span class="text-center" *ngIf="!data.carrier.name">-</span>
                            </div>
                          </div>
                        </div>
                        <div class="col bg-white detailsPadding pl-0 pr-0" *ngFor="let product of data.products">
                          <div class="d-flex borderbottom pl-2 pr-2 pb-2">
                            <div class="col-3">
                              <div class="detailsHeader">#</div>
                            </div>
                            <div class="col">
                              <div class="detailsHeader">Presentation</div>
                            </div>
                            <div class="col-3">
                              <div class="detailsHeader text-end">Unit/Doses</div>
                            </div>
                          </div>
                          <div class="d-flex pt-2 pb-2">
                            <div class="col-3">
                              <div class="detailsHeader"><span>{{product.code}}</span></div>
                            </div>
                            <div class="col">
                              <div class="detailsHeader"><span>{{product.description}}</span></div>
                            </div>
                            <div class="col-3">
                              <div class="detailsHeader text-end">
                                <span>{{product.productUnits}}/{{product.productDoses}}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </td>
              <!-- <td class="statusTd font-weight-bold cursor-pointer" title="{{data.shipmentStatus}}"
              *ngIf="data.shipmentStatus != 'Shipped'">
              <span class="colorCode d-inline-flex mt-0" [ngStyle]="{ 'background': data.statusColor}"></span>
              {{data?.shipmentStatus}}
            </td> -->
              <td class="col-Divider">
                <span *ngIf="data?.shipDate else noShipping"> {{data?.shipDate == 'TBD' ? data?.shipDate :data?.shipDate | date: "MM/dd/yyyy"}} </span>
                <ng-template #noShipping>
                  <span>-</span>
                </ng-template>

              </td>
              <td class="col-Divider">
                {{data.unit}}/{{data.doses}}
              </td>
              <td class="statusTd cursor-pointer">
                <span *ngIf="data?.trackingId else emptyData"
                  (click)="openTrackingURL(data?.trackingId, data?.trackingURL)">
                  {{data.trackingId}}
                </span>
                <ng-template #emptyData>
                  <span class="text-center">-</span>
                </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-12 d-lg-none d-xl-none tableSmDisplay reservationDashboardTableWidth">
          <div class="col-12 p-0 divReservation" *ngFor="let data of reservationData;let j=index">
            <div class="d-flex">
              <div class="col-7 pl-0">
                <label>Shipment Status</label>
              </div>
              <div class="statusTd col-5 pr-0 m-auto" *ngIf="data.shipmentStatus=='Shipped'"
                (click)="openShippingPopup(content); setStatusColorCode(data.shipmentStatus)">
                <span class="colorCode d-inline-flex mt-0" [ngStyle]="{ 'background': data.statusColor }"></span>
                {{data?.shipmentStatus}}
              </div>
              <div class="statusTd col-5 pr-0 m-auto">
                <span class="colorCode d-inline-flex mt-0" [ngStyle]="{ 'background': data.statusColor }"></span>
                {{data?.shipmentStatus}}
              </div>
            </div>
            <div class="d-flex">
              <div class="col-7 pl-0">
                <label>Ship date</label>
              </div>
              <div class="sm-value col-5 pr-0 m-auto">{{data?.shipDate == 'TBD' ? data?.shipDate :data?.shipDate | date: "MM/dd/yyyy"}}</div>
            </div>
            <div class="d-flex">
              <div class="col-7 pl-0">
                <label>Units/Doses</label>
              </div>
              <div class="sm-value col-5 pr-0 m-auto">{{data.unit}}/{{data.doses}}</div>
            </div>
            <div class="d-flex">
              <div class="col-7 pl-0">
                <label>Tracking number</label>
              </div>
              <div class="statusTd col-5 pr-0 m-auto" (click)="openTrackingURL(data?.trackingId, data?.trackingURL)">
                {{data.trackingId}}</div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-between">
          <div class="showingAll pl-0"
            [ngClass]="reservationTableData.length > 5 ? 'col-lg-8 col-md-8' : 'col-12 d-small-flex justify-content-center '">
            <span>Showing {{reservationData.length}} of {{reservationData.length}}</span>
          </div>
          <div class="col-4 pr-0 showingAll" *ngIf="reservationTableData.length > 5 && reservationData.length<=5">
            <a (click)="viewAllShipments()" class="viewAllShipment">View All Shipments</a>
          </div>
        </div>
      </section>
    </ng-template>
  </section>
</section>